module.exports = __webpack_public_path__ + "static/media/mask.0da23768.svg";